/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PreviewRouteImport } from './routes/preview'
import { Route as JunkCheckIndexRouteImport } from './routes/junk-check/index'
import { Route as TelegramAppIndexRouteImport } from './routes/telegram-app/index'
import { Route as TelegramAppSearchRouteImport } from './routes/telegram-app/search'
import { Route as TelegramAppUsersRouteImport } from './routes/telegram-app/users'
import { Route as MailIdIndexRouteImport } from './routes/mail/$id/index'
import { Route as TelegramAppAccountsIndexRouteImport } from './routes/telegram-app/accounts/index'
import { Route as TelegramAppAccountsIdRouteImport } from './routes/telegram-app/accounts/$id'
import { Route as TelegramAppAccountsAddRouteImport } from './routes/telegram-app/accounts/add'
import { Route as TelegramAppListTypeRouteImport } from './routes/telegram-app/list.$type'
import { Route as TelegramAppMailIdRouteImport } from './routes/telegram-app/mail.$id'
import { Route as TelegramAppRemindersIndexRouteImport } from './routes/telegram-app/reminders/index'
import { Route as TelegramAppSettingsIndexRouteImport } from './routes/telegram-app/settings/index'
import { Route as TelegramAppRemindersEditIdRouteImport } from './routes/telegram-app/reminders/edit.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewRoute = PreviewRouteImport.update({
  id: '/preview',
  path: '/preview',
  getParentRoute: () => rootRouteImport,
} as any)
const JunkCheckIndexRoute = JunkCheckIndexRouteImport.update({
  id: '/junk-check/',
  path: '/junk-check/',
  getParentRoute: () => rootRouteImport,
} as any)
const TelegramAppIndexRoute = TelegramAppIndexRouteImport.update({
  id: '/telegram-app/',
  path: '/telegram-app/',
  getParentRoute: () => rootRouteImport,
} as any)
const TelegramAppSearchRoute = TelegramAppSearchRouteImport.update({
  id: '/telegram-app/search',
  path: '/telegram-app/search',
  getParentRoute: () => rootRouteImport,
} as any)
const TelegramAppUsersRoute = TelegramAppUsersRouteImport.update({
  id: '/telegram-app/users',
  path: '/telegram-app/users',
  getParentRoute: () => rootRouteImport,
} as any)
const MailIdIndexRoute = MailIdIndexRouteImport.update({
  id: '/mail/$id/',
  path: '/mail/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const TelegramAppAccountsIndexRoute =
  TelegramAppAccountsIndexRouteImport.update({
    id: '/telegram-app/accounts/',
    path: '/telegram-app/accounts/',
    getParentRoute: () => rootRouteImport,
  } as any)
const TelegramAppAccountsIdRoute = TelegramAppAccountsIdRouteImport.update({
  id: '/telegram-app/accounts/$id',
  path: '/telegram-app/accounts/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TelegramAppAccountsAddRoute = TelegramAppAccountsAddRouteImport.update({
  id: '/telegram-app/accounts/add',
  path: '/telegram-app/accounts/add',
  getParentRoute: () => rootRouteImport,
} as any)
const TelegramAppListTypeRoute = TelegramAppListTypeRouteImport.update({
  id: '/telegram-app/list/$type',
  path: '/telegram-app/list/$type',
  getParentRoute: () => rootRouteImport,
} as any)
const TelegramAppMailIdRoute = TelegramAppMailIdRouteImport.update({
  id: '/telegram-app/mail/$id',
  path: '/telegram-app/mail/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const TelegramAppRemindersIndexRoute =
  TelegramAppRemindersIndexRouteImport.update({
    id: '/telegram-app/reminders/',
    path: '/telegram-app/reminders/',
    getParentRoute: () => rootRouteImport,
  } as any)
const TelegramAppSettingsIndexRoute =
  TelegramAppSettingsIndexRouteImport.update({
    id: '/telegram-app/settings/',
    path: '/telegram-app/settings/',
    getParentRoute: () => rootRouteImport,
  } as any)
const TelegramAppRemindersEditIdRoute =
  TelegramAppRemindersEditIdRouteImport.update({
    id: '/telegram-app/reminders/edit/$id',
    path: '/telegram-app/reminders/edit/$id',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/preview': typeof PreviewRoute
  '/telegram-app/search': typeof TelegramAppSearchRoute
  '/telegram-app/users': typeof TelegramAppUsersRoute
  '/junk-check/': typeof JunkCheckIndexRoute
  '/telegram-app/': typeof TelegramAppIndexRoute
  '/telegram-app/accounts/$id': typeof TelegramAppAccountsIdRoute
  '/telegram-app/accounts/add': typeof TelegramAppAccountsAddRoute
  '/telegram-app/list/$type': typeof TelegramAppListTypeRoute
  '/telegram-app/mail/$id': typeof TelegramAppMailIdRoute
  '/mail/$id/': typeof MailIdIndexRoute
  '/telegram-app/accounts/': typeof TelegramAppAccountsIndexRoute
  '/telegram-app/reminders/': typeof TelegramAppRemindersIndexRoute
  '/telegram-app/settings/': typeof TelegramAppSettingsIndexRoute
  '/telegram-app/reminders/edit/$id': typeof TelegramAppRemindersEditIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/preview': typeof PreviewRoute
  '/telegram-app/search': typeof TelegramAppSearchRoute
  '/telegram-app/users': typeof TelegramAppUsersRoute
  '/junk-check': typeof JunkCheckIndexRoute
  '/telegram-app': typeof TelegramAppIndexRoute
  '/telegram-app/accounts/$id': typeof TelegramAppAccountsIdRoute
  '/telegram-app/accounts/add': typeof TelegramAppAccountsAddRoute
  '/telegram-app/list/$type': typeof TelegramAppListTypeRoute
  '/telegram-app/mail/$id': typeof TelegramAppMailIdRoute
  '/mail/$id': typeof MailIdIndexRoute
  '/telegram-app/accounts': typeof TelegramAppAccountsIndexRoute
  '/telegram-app/reminders': typeof TelegramAppRemindersIndexRoute
  '/telegram-app/settings': typeof TelegramAppSettingsIndexRoute
  '/telegram-app/reminders/edit/$id': typeof TelegramAppRemindersEditIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/preview': typeof PreviewRoute
  '/telegram-app/search': typeof TelegramAppSearchRoute
  '/telegram-app/users': typeof TelegramAppUsersRoute
  '/junk-check/': typeof JunkCheckIndexRoute
  '/telegram-app/': typeof TelegramAppIndexRoute
  '/telegram-app/accounts/$id': typeof TelegramAppAccountsIdRoute
  '/telegram-app/accounts/add': typeof TelegramAppAccountsAddRoute
  '/telegram-app/list/$type': typeof TelegramAppListTypeRoute
  '/telegram-app/mail/$id': typeof TelegramAppMailIdRoute
  '/mail/$id/': typeof MailIdIndexRoute
  '/telegram-app/accounts/': typeof TelegramAppAccountsIndexRoute
  '/telegram-app/reminders/': typeof TelegramAppRemindersIndexRoute
  '/telegram-app/settings/': typeof TelegramAppSettingsIndexRoute
  '/telegram-app/reminders/edit/$id': typeof TelegramAppRemindersEditIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/preview'
    | '/telegram-app/search'
    | '/telegram-app/users'
    | '/junk-check/'
    | '/telegram-app/'
    | '/telegram-app/accounts/$id'
    | '/telegram-app/accounts/add'
    | '/telegram-app/list/$type'
    | '/telegram-app/mail/$id'
    | '/mail/$id/'
    | '/telegram-app/accounts/'
    | '/telegram-app/reminders/'
    | '/telegram-app/settings/'
    | '/telegram-app/reminders/edit/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/preview'
    | '/telegram-app/search'
    | '/telegram-app/users'
    | '/junk-check'
    | '/telegram-app'
    | '/telegram-app/accounts/$id'
    | '/telegram-app/accounts/add'
    | '/telegram-app/list/$type'
    | '/telegram-app/mail/$id'
    | '/mail/$id'
    | '/telegram-app/accounts'
    | '/telegram-app/reminders'
    | '/telegram-app/settings'
    | '/telegram-app/reminders/edit/$id'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/preview'
    | '/telegram-app/search'
    | '/telegram-app/users'
    | '/junk-check/'
    | '/telegram-app/'
    | '/telegram-app/accounts/$id'
    | '/telegram-app/accounts/add'
    | '/telegram-app/list/$type'
    | '/telegram-app/mail/$id'
    | '/mail/$id/'
    | '/telegram-app/accounts/'
    | '/telegram-app/reminders/'
    | '/telegram-app/settings/'
    | '/telegram-app/reminders/edit/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  PreviewRoute: typeof PreviewRoute
  TelegramAppSearchRoute: typeof TelegramAppSearchRoute
  TelegramAppUsersRoute: typeof TelegramAppUsersRoute
  JunkCheckIndexRoute: typeof JunkCheckIndexRoute
  TelegramAppIndexRoute: typeof TelegramAppIndexRoute
  TelegramAppAccountsIdRoute: typeof TelegramAppAccountsIdRoute
  TelegramAppAccountsAddRoute: typeof TelegramAppAccountsAddRoute
  TelegramAppListTypeRoute: typeof TelegramAppListTypeRoute
  TelegramAppMailIdRoute: typeof TelegramAppMailIdRoute
  MailIdIndexRoute: typeof MailIdIndexRoute
  TelegramAppAccountsIndexRoute: typeof TelegramAppAccountsIndexRoute
  TelegramAppRemindersIndexRoute: typeof TelegramAppRemindersIndexRoute
  TelegramAppSettingsIndexRoute: typeof TelegramAppSettingsIndexRoute
  TelegramAppRemindersEditIdRoute: typeof TelegramAppRemindersEditIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview': {
      id: '/preview'
      path: '/preview'
      fullPath: '/preview'
      preLoaderRoute: typeof PreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/junk-check/': {
      id: '/junk-check/'
      path: '/junk-check'
      fullPath: '/junk-check/'
      preLoaderRoute: typeof JunkCheckIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telegram-app/': {
      id: '/telegram-app/'
      path: '/telegram-app'
      fullPath: '/telegram-app/'
      preLoaderRoute: typeof TelegramAppIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telegram-app/search': {
      id: '/telegram-app/search'
      path: '/telegram-app/search'
      fullPath: '/telegram-app/search'
      preLoaderRoute: typeof TelegramAppSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telegram-app/users': {
      id: '/telegram-app/users'
      path: '/telegram-app/users'
      fullPath: '/telegram-app/users'
      preLoaderRoute: typeof TelegramAppUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mail/$id/': {
      id: '/mail/$id/'
      path: '/mail/$id'
      fullPath: '/mail/$id/'
      preLoaderRoute: typeof MailIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telegram-app/accounts/': {
      id: '/telegram-app/accounts/'
      path: '/telegram-app/accounts'
      fullPath: '/telegram-app/accounts/'
      preLoaderRoute: typeof TelegramAppAccountsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telegram-app/accounts/$id': {
      id: '/telegram-app/accounts/$id'
      path: '/telegram-app/accounts/$id'
      fullPath: '/telegram-app/accounts/$id'
      preLoaderRoute: typeof TelegramAppAccountsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telegram-app/accounts/add': {
      id: '/telegram-app/accounts/add'
      path: '/telegram-app/accounts/add'
      fullPath: '/telegram-app/accounts/add'
      preLoaderRoute: typeof TelegramAppAccountsAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telegram-app/list/$type': {
      id: '/telegram-app/list/$type'
      path: '/telegram-app/list/$type'
      fullPath: '/telegram-app/list/$type'
      preLoaderRoute: typeof TelegramAppListTypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telegram-app/mail/$id': {
      id: '/telegram-app/mail/$id'
      path: '/telegram-app/mail/$id'
      fullPath: '/telegram-app/mail/$id'
      preLoaderRoute: typeof TelegramAppMailIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telegram-app/reminders/': {
      id: '/telegram-app/reminders/'
      path: '/telegram-app/reminders'
      fullPath: '/telegram-app/reminders/'
      preLoaderRoute: typeof TelegramAppRemindersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telegram-app/settings/': {
      id: '/telegram-app/settings/'
      path: '/telegram-app/settings'
      fullPath: '/telegram-app/settings/'
      preLoaderRoute: typeof TelegramAppSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/telegram-app/reminders/edit/$id': {
      id: '/telegram-app/reminders/edit/$id'
      path: '/telegram-app/reminders/edit/$id'
      fullPath: '/telegram-app/reminders/edit/$id'
      preLoaderRoute: typeof TelegramAppRemindersEditIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  PreviewRoute: PreviewRoute,
  TelegramAppSearchRoute: TelegramAppSearchRoute,
  TelegramAppUsersRoute: TelegramAppUsersRoute,
  JunkCheckIndexRoute: JunkCheckIndexRoute,
  TelegramAppIndexRoute: TelegramAppIndexRoute,
  TelegramAppAccountsIdRoute: TelegramAppAccountsIdRoute,
  TelegramAppAccountsAddRoute: TelegramAppAccountsAddRoute,
  TelegramAppListTypeRoute: TelegramAppListTypeRoute,
  TelegramAppMailIdRoute: TelegramAppMailIdRoute,
  MailIdIndexRoute: MailIdIndexRoute,
  TelegramAppAccountsIndexRoute: TelegramAppAccountsIndexRoute,
  TelegramAppRemindersIndexRoute: TelegramAppRemindersIndexRoute,
  TelegramAppSettingsIndexRoute: TelegramAppSettingsIndexRoute,
  TelegramAppRemindersEditIdRoute: TelegramAppRemindersEditIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
